import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILED,
  EDIT_NOTIFICATIONS,
  SEND_NOTIFICATION,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_FAILED,
} from "../store/types";
import { RequestPushMsg, isExpoPushToken } from '../other/NotificationFunctions';
import { firebase } from '../config/configureFirebase';
import { onValue, set, push, remove } from "firebase/database";
import store from '../store/store';
import getCurrentUid from '../other/getCurrentUid';

const normalizeEmail = (email) =>
  typeof email === 'string' ? email.trim().toLowerCase() : '';

export const fetchUserNotifications = () => (dispatch) => {

  const {
    auth,
    userNotificationsRef
  } = firebase;

  dispatch({
    type: FETCH_NOTIFICATIONS,
    payload: null
  });

  const uid = getCurrentUid(auth);
  if (!uid) return;

  onValue(userNotificationsRef(uid), snapshot => {
    const data = snapshot.val(); 
    if(data){
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: arr.reverse()
      });
    } else {
      dispatch({
        type: FETCH_NOTIFICATIONS_FAILED,
        payload: "No data available."
      });
    }
  });
};

export const fetchNotifications = () => (dispatch) => {

  const {
    notifyRef
  } = firebase;

  dispatch({
    type: FETCH_NOTIFICATIONS,
    payload: null
  });
  onValue(notifyRef, snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();

      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });

      dispatch({
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_NOTIFICATIONS_FAILED,
        payload: "No data available."
      });
    }
  });
};

export const editNotifications = (notification, method) => (dispatch) => {
  const {
    notifyRef,
    notifyEditRef
  } = firebase;
  dispatch({
    type: EDIT_NOTIFICATIONS,
    payload: { method, notification }
  });
  if (method === 'Add') {
    push(notifyRef, notification);
  } else if (method === 'Delete') {
    remove(notifyEditRef(notification.id));
  } else {
    set(notifyEditRef(notification.id), notification);
  }
}

export const sendNotification = (notification) => async (dispatch) => {

  dispatch({
    type: SEND_NOTIFICATION,
    payload: notification
  });

  const users = store.getState().usersdata.users;
  if (users) {
    const tokenSet = new Set();
    const targetEmailSet = Array.isArray(notification.targetEmails) && notification.targetEmails.length > 0
      ? new Set(notification.targetEmails.map(normalizeEmail).filter(Boolean))
      : null;
    let matchedUserCount = 0;
    let invalidTokenCount = 0;

    for (let i = 0; i < users.length; i++) {
      const usr = users[i];

      let matchesSegment = false;
      if (targetEmailSet) {
        matchesSegment = targetEmailSet.has(normalizeEmail(usr.email));
      } else {
        if (notification.usertype === 'All' && notification.devicetype === 'All') {
          matchesSegment = true;
        } else if (notification.usertype === 'All' && notification.devicetype !== 'All') {
          matchesSegment = usr.userPlatform === notification.devicetype;
        } else if (notification.usertype !== 'All' && notification.devicetype === 'All') {
          matchesSegment = usr.usertype === notification.usertype;
        } else {
          matchesSegment =
            usr.usertype === notification.usertype &&
            usr.userPlatform === notification.devicetype;
        }
      }

      if (!matchesSegment) {
        continue;
      }

      matchedUserCount += 1;

      if (isExpoPushToken(usr.pushToken)) {
        tokenSet.add(usr.pushToken);
      } else if (usr.pushToken && usr.pushToken !== 'web' && usr.pushToken !== 'token_error') {
        invalidTokenCount += 1;
      }
    }

    const tokens = Array.from(tokenSet);

    if (tokens.length > 0) {
      const chunkSize = 100;
      const requests = [];

      for (let i = 0; i < tokens.length; i += chunkSize) {
          const chunk = tokens.slice(i, i + chunkSize);
          requests.push(RequestPushMsg(chunk, {
            title: notification.title, msg: notification.body, screen: "Notifications"
          }));
      }

      const results = await Promise.all(requests);
      const summary = results.reduce((acc, result) => {
        acc.successCount += result.successCount || 0;
        acc.errorCount += result.errorCount || 0;
        acc.invalidTokenCount += result.invalidTokenCount || 0;
        return acc;
      }, {
        successCount: 0,
        errorCount: 0,
        invalidTokenCount,
      });

      const ok = summary.successCount > 0;

      if (!ok) {
        dispatch({
          type: SEND_NOTIFICATION_FAILED,
          payload: store.getState().languagedata.defaultLanguage.update_failed,
        });

        return {
          ok: false,
          matchedUserCount,
          validTokenCount: tokens.length,
          ...summary,
          message: store.getState().languagedata.defaultLanguage.update_failed,
        };
      }

      dispatch({
        type: SEND_NOTIFICATION_SUCCESS,
        payload: {
          tokens,
          matchedUserCount,
          ...summary,
        }
      });

      return {
        ok: true,
        matchedUserCount,
        validTokenCount: tokens.length,
        ...summary,
      };
    } else {
      dispatch({
        type: SEND_NOTIFICATION_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_user_match,
      });

      return {
        ok: false,
        matchedUserCount,
        validTokenCount: 0,
        invalidTokenCount,
        successCount: 0,
        errorCount: 0,
        message: store.getState().languagedata.defaultLanguage.no_user_match,
      };
    }
  } else {
    dispatch({
      type: SEND_NOTIFICATION_FAILED,
      payload: store.getState().languagedata.defaultLanguage.no_user_match,
    });

    return {
      ok: false,
      matchedUserCount: 0,
      validTokenCount: 0,
      invalidTokenCount: 0,
      successCount: 0,
      errorCount: 0,
      message: store.getState().languagedata.defaultLanguage.no_user_match,
    };
  }
}
